import DirectCallLandingView from "../components/landing/directCall/DirectCallLandingView";

const LandingDirectCall2 = () => (
  <DirectCallLandingView
    landingName="landing-direct-call-2"
    phoneDisplay="02 4873 1550"
    phoneTel="tel:+390248731550"
  />
);

export default LandingDirectCall2;
